import React, { useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import { helpCategories } from "../help/helpData";
import HelpCenterLayout from "../help/HelpCenterLayout";
import Breadcrumbs from "../help/Breadcrumbs";
import ArticleList from "../help/ArticleList";
import "../../css/HelpCenter.css";

const HELP_BASE_PATH = "/help-archive";

const HelpArchiveCategoryDetails = () => {
  const { categoryId } = useParams();
  const category = useMemo(
    () => helpCategories.find((item) => item.id === categoryId),
    [categoryId]
  );

  useEffect(() => {
    document.title = category
      ? `VelaKoda | ${category.title} Archive`
      : "VelaKoda | Help Center Archive";
  }, [category]);

  if (!category) {
    return (
      <HelpCenterLayout backFallbackTo={HELP_BASE_PATH}>
        <Breadcrumbs
          items={[
            { label: "All Collections", to: HELP_BASE_PATH },
            { label: "Category not found", muted: true },
          ]}
        />
        <header className="help-page-header">
          <h1 className="help-page-title">Category not found</h1>
        </header>
        <div className="help-empty-state">
          Please choose a different topic from the Help Center Archive.
        </div>
      </HelpCenterLayout>
    );
  }

  return (
    <HelpCenterLayout backFallbackTo={HELP_BASE_PATH}>
      <Breadcrumbs
        items={[
          { label: "All Collections", to: HELP_BASE_PATH },
          { label: category.title },
        ]}
      />

      <header className="help-page-header">
        <h1 className="help-page-title">{category.title}</h1>
        <p className="help-page-subtitle">
          {category.summary} ({category.articles.length} articles)
        </p>
      </header>

      <div className="help-list-shell">
        <ArticleList
          articles={category.articles}
          basePath={`${HELP_BASE_PATH}/${category.id}`}
        />
      </div>
    </HelpCenterLayout>
  );
};

export default HelpArchiveCategoryDetails;
